import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";

// Pages
import LandingPage from "@/pages/LandingPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import BookingWidget from "@/pages/BookingWidget";
import PaymentPage from "@/pages/PaymentPage";
import CancelBooking from "@/pages/CancelBooking";
import AdminLogin from "@/pages/AdminLogin";
import AdminRegister from "@/pages/AdminRegister";
import AdminPinLogin from "@/pages/AdminPinLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminBookings from "@/pages/AdminBookings";
import AdminSettings from "@/pages/AdminSettings";
import AdminEvents from "@/pages/AdminEvents";
import AdminEventGuests from "@/pages/AdminEventGuests";
import EventPage from "@/pages/EventPage";
import EventSuccess from "@/pages/EventSuccess";
import EventCheckIn from "@/pages/EventCheckIn";
import PlatformImportBookings from "@/pages/PlatformImportBookings";
import TabletView from "@/pages/TabletView";
import PlatformDashboard from "@/pages/PlatformDashboard";
import TenantProtectedRoute from "@/components/TenantProtectedRoute";
import TenantPermissionRoute from "@/components/TenantPermissionRoute";
import PlatformProtectedRoute from "@/components/PlatformProtectedRoute";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/book/:restaurantId" element={<BookingWidget />} />
          <Route path="/book/:restaurantId/pay/:bookingId" element={<PaymentPage />} />
          <Route path="/book/:restaurantId/payment-success" element={<BookingWidget />} />
          <Route path="/book/:restaurantId/payment-cancelled" element={<BookingWidget />} />
          <Route path="/cancel/:bookingId/:cancellationToken" element={<CancelBooking />} />
          
          {/* Auth Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/register" element={<AdminRegister />} />
          <Route path="/admin/pin-login" element={<AdminPinLogin />} />
          
          {/* Protected Admin Routes (restaurant staff) */}
          <Route path="/admin" element={<TenantProtectedRoute><Navigate to="/admin/dashboard" replace /></TenantProtectedRoute>} />
          <Route path="/admin/dashboard" element={<TenantProtectedRoute><TenantPermissionRoute permission="dashboard"><AdminDashboard /></TenantPermissionRoute></TenantProtectedRoute>} />
          <Route path="/admin/bookings" element={<TenantProtectedRoute><TenantPermissionRoute permission="bookings"><AdminBookings /></TenantPermissionRoute></TenantProtectedRoute>} />
          <Route path="/admin/settings" element={<TenantProtectedRoute><TenantPermissionRoute permission="settings"><AdminSettings /></TenantPermissionRoute></TenantProtectedRoute>} />
          <Route path="/admin/events" element={<TenantProtectedRoute><AdminEvents /></TenantProtectedRoute>} />
          <Route path="/admin/events/:eventId/guests" element={<TenantProtectedRoute><AdminEventGuests /></TenantProtectedRoute>} />
          <Route path="/admin/events/:eventId/check-in" element={<TenantProtectedRoute><EventCheckIn /></TenantProtectedRoute>} />

          {/* Public Event Pages */}
          <Route path="/event/:eventId" element={<EventPage />} />
          <Route path="/event/:eventId/success" element={<EventSuccess />} />

          {/* Tablet View (Protected) */}
          <Route path="/tablet" element={<TenantProtectedRoute><TenantPermissionRoute permission="tablet"><TabletView /></TenantPermissionRoute></TenantProtectedRoute>} />

          {/* Platform (SaaS operator) */}
          <Route path="/platform" element={<Navigate to="/platform/dashboard" replace />} />
          <Route path="/platform/dashboard" element={<PlatformProtectedRoute><PlatformDashboard /></PlatformProtectedRoute>} />
          <Route path="/platform/import" element={<PlatformProtectedRoute><PlatformImportBookings /></PlatformProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
